import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';

import { BrandService } from '@app/services/brand.service';
import { DisconnectButtonComponent } from '@app/shared/disconnect-button/disconnect-button.component';
import { MainStatusbarComponent } from '@app/shared/main-statusbar/main-statusbar.component';
import { ReleaseInfoComponent } from '@app/shared/release-info/release-info.component';
import { SaveProblemReportButtonComponent } from '@app/shared/save-problem-report-button/save-problem-report-button.component';
import { SwitchBackButtonComponent } from '@app/shared/switch-back-button/switch-back-button.component';
import { UpdateSoftwareButtonComponent } from '@app/shared/update-software-button.component';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  imports: [
    RouterLink,
    SwitchBackButtonComponent,
    UpdateSoftwareButtonComponent,
    SaveProblemReportButtonComponent,
    DisconnectButtonComponent,
    ReleaseInfoComponent,
    MainStatusbarComponent,
    AsyncPipe,
  ],
})
export class PageNotFoundComponent {
  private brandService = inject(BrandService);

  logoUrl$ = this.brandService.logoUrl$;
  brandName$ = this.brandService.brandName$;
  isOblacDrivesBrand$ = this.brandService.isOblacDrivesBrand$;
}
